import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    HttpClientModule,
} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { PermissionsPipe } from './core/pipe/permissions.pipe';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { DocViewersComponent } from './views/components/doc-viewers/doc-viewers.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxSummernoteModule } from 'ngx-summernote';
import { DecodeURIComponentPipe } from './core/pipe/decode-uricomponent.pipe';
import { TitleService } from './core/services/title.service';
import { TokenReplaceInterceptor } from './core/interceptors/token-replace.interceptor';
import { RouteReuseStrategy } from '@angular/router';
import { DynamicRouteReuseStrategy } from './core/helpers/single-component-route-reuse-strategy';
import { LoaderInterceptorInterceptor } from './core/interceptors/loader-interceptor.interceptor';
import { CallLogsComponent } from './views/call-logs/call-logs.component';
import { EncryptionInterceptor } from './core/interceptors/encrypt.interceptor';
// import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
// import { provideMessaging, getMessaging } from '@angular/fire/messaging';
// Firebase imports
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
// import { AutomationLogAsiaTimestampConverterPipe } from './core/pipe/automation-log-asia-timestamp-converter.pipe';


export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent, DocViewersComponent, DecodeURIComponentPipe,CallLogsComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        CarouselModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        ToastrModule.forRoot({ preventDuplicates: true }),
        NgxDocViewerModule,
        NgxSummernoteModule,
        // provideFirebaseApp(() => initializeApp(environment.firebase)),
        AngularFireModule.initializeApp({
        apiKey: "AIzaSyDaYhv_pJPvWjzENacvyMKqy3-I-dvFxNk",
        authDomain: "crizac-mail-812c4.firebaseapp.com",
        projectId: "crizac-mail-812c4",
        storageBucket: "crizac-mail-812c4.firebasestorage.app",
        messagingSenderId: "576816357859",
        appId: "1:576816357859:web:842a067276e081c90b00d6",
        measurementId: "G-NH8QT8M333"

        // apiKey: "AIzaSyBfG3i3fd0Q1ApHR71KDgdV4qtXpz5OwWs",
        // authDomain: "testing-b5e0a.firebaseapp.com",
        // projectId: "testing-b5e0a",
        // storageBucket: "testing-b5e0a.firebasestorage.app",
        // messagingSenderId: "1013575784489",
        // appId: "1:1013575784489:web:23a64f5b26cae1dfe5a438",
        // measurementId: "G-NHJ27CLC08"
        }),
        AngularFireMessagingModule,   
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: EncryptionInterceptor, multi: true },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: DuplicateRequestInterceptor,
        //     multi: true
        // },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenReplaceInterceptor,
            multi: true
        },
        DatePipe,
        PermissionsPipe,
        TitleService,
        { provide: RouteReuseStrategy, useClass: DynamicRouteReuseStrategy },
        // provideFirebaseApp(() => initializeApp({
        // apiKey: "AIzaSyBfG3i3fd0Q1ApHR71KDgdV4qtXpz5OwWs",
        // authDomain: "testing-b5e0a.firebaseapp.com",
        // projectId: "testing-b5e0a",
        // storageBucket: "testing-b5e0a.firebasestorage.app",
        // messagingSenderId: "1013575784489",
        // appId: "1:1013575784489:web:23a64f5b26cae1dfe5a438",
        // measurementId: "G-NHJ27CLC08"
        // })),
        // provideMessaging(() => getMessaging()),
    ],
    exports: [],
    bootstrap: [AppComponent], 
})
export class AppModule { }